import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { CS_FONT, CS_WEIGHT, csTokens, glassSurface } from 'components/CallScribe/callScribeTheme';

const DOT = 28;

const usePopupLaunchStyles = makeStyles((theme: Theme) => ({
  steps: {
    alignSelf: 'center',
    listStyle: 'none',
    margin: 0,
    padding: theme.spacing(0, 2),
    width: '100%',
    maxWidth: 360,
    boxSizing: 'border-box',
    borderRadius: 12,
    ...glassSurface(theme),
  },
  step: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minHeight: 44,
    padding: theme.spacing(1.5, 0),
    '& + &': {
      borderTop: `1px solid ${csTokens(theme).glassBorder}`,
    },
  },
  dot: {
    width: DOT,
    height: DOT,
    flex: '0 0 auto',
    borderRadius: 999,
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `2px solid ${csTokens(theme).onGroundMuted}`,
    color: csTokens(theme).ground,
  },
  dotDone: {
    background: csTokens(theme).stageCall,
    borderColor: csTokens(theme).stageCall,
    color: csTokens(theme).stageCallInk,
  },
  dotNow: {
    borderColor: csTokens(theme).stageFocus,
    borderRightColor: 'transparent',
    animation: '$turn 900ms linear infinite',
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
      borderRightColor: csTokens(theme).stageFocus,
    },
  },
  '@keyframes turn': {
    to: {
      transform: 'rotate(360deg)',
    },
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    minWidth: 0,
  },
  title: {
    ...CS_FONT.body,
    fontWeight: CS_WEIGHT.strong,
    color: csTokens(theme).onGround,
    overflowWrap: 'anywhere',
  },
  titleNext: {
    color: csTokens(theme).onGroundMuted,
    fontWeight: CS_WEIGHT.regular,
  },
  detail: {
    ...CS_FONT.small,
    color: csTokens(theme).onGroundMuted,
    overflowWrap: 'anywhere',
  },
  liveRegion: {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    border: 0,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
  },
}));

export default usePopupLaunchStyles;
